// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  API_TIMEOUT: 30 * 1000,
  V1_KEY: 'sajkghdakg326t2876428hjbsdhjfg238',
  BASE_URL: 'https://api.staging.iofteam.com/api/v1/',
  KEYSTORE: 'DigiMEP',
};
